import {
  BarcodeOutlined,
  ContainerOutlined,
  FileSearchOutlined,
  LeftOutlined,
  RedoOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Col, Input, Row } from "antd";
import CategoryList from "./CategoryList";
import { useRef, useState, useEffect } from "react";
import CheckoutNew from "./CheckoutNew";
import { useQuery, useMutation } from "react-query";
import ItemsListNew from "./ItemsListNew";
import { getCategory } from "../../api/category";
import { useDispatch, useSelector } from "react-redux";
import VoidOrder from "./Modals/VoidOrder/VoidOrder";
import RestoreOrder from "./Modals/RestoreOrder/RestorOrders";
import Hold from "./Modals/Hold/Hold";
import { useTranslation } from "react-i18next";
import { getCurrentPriceByCategory } from "../../api/pricesCurrent";
//import useScanDetection from "use-scan-detection";
import { mainActions } from "../../store/main/mainSlice";
import { getCurrentPrices } from "../../api/pricesCurrent";
const MainThree = () => {
  const categoryListRef = useRef<HTMLDivElement>(null);
  const [selectedCategory, setSelectedCategory] = useState(4);
  const [isRestoreOpen, setIsRestoreOpen] = useState(false);
  const [dbItems, setDbItems] = useState<any>();
  const [barcode, setBarcode] = useState<string>();
  const [search, setSearch] = useState<string>();
  const { t } = useTranslation("common");

  const dispatch = useDispatch();

  const { data: allItems } = useQuery("items", () => getCurrentPrices("", 20));

  const { mutateAsync: getItemsByCategoryMutation, isLoading: isItemsLoading } =
    useMutation("items", () =>
      getCurrentPriceByCategory({ q: "", categoryId: selectedCategory, warehouseId: 1 })
    );

  const { data: categories } = useQuery("categories", getCategory, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setSelectedCategory(res.data[0].id);
    },
  });

  useEffect(() => {
    getItemsByCategoryMutation().then((res) => {
      setDbItems(res?.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory]);

  const items = useSelector((state: any) => state.main.items);

  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      updateScrollArrows();
    };

    if (categoryListRef.current) {
      categoryListRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (categoryListRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        categoryListRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const updateScrollArrows = () => {
    if (categoryListRef.current) {
      const scrollLeft = categoryListRef.current.scrollLeft;
      const maxScrollLeft =
        categoryListRef.current.scrollWidth -
        categoryListRef.current.offsetWidth;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < maxScrollLeft);

      // Hide scroll arrows when there is no more content to scroll
      if (scrollLeft === maxScrollLeft) {
        setShowRightArrow(false);
      } else if (scrollLeft < 100) {
        setShowLeftArrow(false);
      }
    }
  };

  const handleScrollLeft = (): void => {
    if (categoryListRef.current) {
      const targetScroll: number =
        categoryListRef.current.scrollLeft -
        categoryListRef.current.offsetWidth;
      const options: ScrollToOptions = {
        left: targetScroll,
        top: 0,
        behavior: "smooth",
      };
      categoryListRef.current.scroll(options);
    }
  };

  const handleScrollRight = (): void => {
    if (categoryListRef.current) {
      const targetScroll =
        categoryListRef.current.scrollLeft +
        categoryListRef.current.offsetWidth;
      const options: ScrollToOptions = {
        left: targetScroll,
        top: 0,
        behavior: "smooth",
      };
      categoryListRef.current.scroll(options);
    }
  };

  useEffect(() => {
    search
      ? setDbItems(
        allItems?.data.filter((item: any) =>
          item.item.name.toString().includes(search)
        )
      )
      : getItemsByCategoryMutation().then((res) => {
        setDbItems(res?.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  let barcodeScan = "";

  useEffect(() => {
    const handleKeyDown = (e: any) => {
      if (e.keyCode === 13 && barcodeScan.length > 3) {
        handleScan(barcodeScan);
        barcodeScan = "";
        return;
      }
      if (e.keyCode === 16) {
        return;
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      barcodeScan += e.key;

      setTimeout(() => {
        barcodeScan = "";
      }, 150);
    };

    document.addEventListener("keydown", handleKeyDown);

    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });

  const handleScan = (barcodeString: string) => {
    if (barcodeString) {
      const item = allItems?.data.filter(
        (item: any) => item?.item?.barcode === String(barcodeString)
      );
      if (item.length > 0) {
        dispatch(
          mainActions.addItem({
            name: item[0]?.item.name,
            itemId: item[0]?.item.id,
            barcode: item[0]?.item.barcode,
            cost: item[0]?.averageCost,
            price: item[0]?.averagePrice,
            totalPrice: item[0]?.averagePrice,
            isTaxable: false,
            extraCharge: 0,
            tax: 10,
            discount: null,
            notes: "Example sale item notes",
            qty: 1,
            specifications: [],
          })
        );
      } else {
      }
    }
  };

  return (
    <>
      <Row>
        <Col span={15}>
          <Row gutter={[18, 0]}>
            <Col offset={1} span={10}>
              <Input
                type="number"
                className="btn-shadow"
                placeholder={`${t("barcode")}`}
                onFocus={() => setSearch("")}
                value={barcode}
                onPressEnter={() => {
                  const item = allItems?.data.filter(
                    (item: any) => item?.item?.barcode === String(barcode)
                  );
                  if (item.length > 0) {
                    dispatch(
                      mainActions.addItem({
                        name: item[0]?.item.name,
                        itemId: item[0]?.item.id,
                        barcode: item[0]?.item.barcode,
                        cost: item[0]?.averageCost,
                        price: item[0]?.averagePrice,
                        totalPrice: item[0]?.averagePrice,
                        isTaxable: false,
                        extraCharge: 0,
                        tax: 10,
                        discount: null,
                        notes: "Example sale item notes",
                        qty: 1,
                        specifications: [],
                      })
                    );
                  } else {
                  }
                  setBarcode("");
                }}
                onChange={(e) => {
                  setBarcode(e.target.value.toString());
                }}
                suffix={
                  <BarcodeOutlined
                    style={{ fontSize: "20px", color: "#8C8C8C" }}
                  />
                }
              />
            </Col>
            <Col span={11}>
              <Input
                onFocus={() => setBarcode("")}
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value.toString());
                }}
                placeholder="Search..."
                suffix={
                  <FileSearchOutlined
                    style={{ fontSize: "20px", color: "#8C8C8C" }}
                  />
                }
              />
            </Col>
            <Col span={1} style={{ display: "flex", alignItems: "center" }}>
              {showLeftArrow && (
                <LeftOutlined
                  style={{ fontSize: "24px", cursor: "pointer" }}
                  onClick={() => handleScrollLeft()}
                />
              )}
            </Col>
            <Col span={1} style={{ display: "flex", alignItems: "center" }}>
              {showRightArrow && (
                <RightOutlined
                  style={{ fontSize: "24px", cursor: "pointer" }}
                  onClick={() => handleScrollRight()}
                />
              )}
            </Col>
          </Row>
          <Row className="category-list" wrap={false} ref={categoryListRef}>
            <CategoryList
              categories={categories?.data}
              setSelectedCategory={setSelectedCategory}
              selectedCategory={selectedCategory}
            />
          </Row>
          <Row className="cards-list" gutter={[0, 10]} justify="start">
            {isItemsLoading ? "Loading..." : <ItemsListNew items={dbItems} />}
          </Row>
        </Col>
        <Col span={9} style={{ marginTop: "12px" }}>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <Col offset={16} span={2}>
              <RedoOutlined
                onClick={() => {
                  items.length === 0 && setIsRestoreOpen(true);
                }}
                style={
                  items.length === 0
                    ? {
                      fontSize: "24px",
                      color: "#F67600",
                      cursor: "pointer",
                    }
                    : {
                      fontSize: "24px",
                      color: "#9e9e9e",
                      cursor: "not-allowed",
                    }
                }
              />
            </Col>
            <Col span={2}>
              <Hold />
            </Col>
            <Col span={2}>
              <VoidOrder />
            </Col>
            <Col span={2}>
              <ContainerOutlined
                style={{ fontSize: "24px", cursor: "pointer" }}
              />
            </Col>
          </Row>
          <Row
            style={{
              backgroundColor: "#EEF5FF",
              minHeight: "80vh",
              borderRadius: "10px",
              marginTop: "20px",
              padding: "10px",
            }}
          >
            <CheckoutNew />
          </Row>
        </Col>
      </Row>

      <RestoreOrder
        setIsRestoreOpen={setIsRestoreOpen}
        isRestoreOpen={isRestoreOpen}
      />
    </>
  );
};

export default MainThree;
